/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginRequest } from '../models/LoginRequest';
import type { LoginResponse } from '../models/LoginResponse';
import type { MailAuthenticationRequest } from '../models/MailAuthenticationRequest';
import type { MailAuthenticationResponse } from '../models/MailAuthenticationResponse';
import type { MailForm } from '../models/MailForm';
import type { PasswordChangeForm } from '../models/PasswordChangeForm';
import type { PasswordResetForm } from '../models/PasswordResetForm';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthenticationRepository {

  /**
   * メール認証
   * @returns MailAuthenticationResponse 認証成功
   * @throws ApiError
   */
  public static mailAuthentication({
    requestBody,
  }: {
    requestBody: MailAuthenticationRequest,
  }): CancelablePromise<MailAuthenticationResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/mail',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
      },
    });
  }

  /**
   * ログイン
   * @returns LoginResponse ログイン成功時、Cookie名SESSIONにSESSIONIDを設定して返却する。
   * @throws ApiError
   */
  public static login({
    requestBody,
  }: {
    requestBody: LoginRequest,
  }): CancelablePromise<LoginResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/login',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
      },
    });
  }

  /**
   * パスワード変更
   * @returns any OK
   * @throws ApiError
   */
  public static change({
    requestBody,
  }: {
    requestBody: PasswordChangeForm,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/login/password/change',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * パスワード再設定
   * @returns any OK
   * @throws ApiError
   */
  public static resetPassword({
    requestBody,
  }: {
    requestBody: PasswordResetForm,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/login/password/reset',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * パスワード再設定用メール送信
   * @returns any 指定したmailAddressにメールが送信される。メール内のURL(https://dev-2023-09-admin.walletstation.org/admin/password/reset?token=asd;lgkjaia)にアクセスしてパスワード再設定を行う。
   * @throws ApiError
   */
  public static sendPasswordResetMail({
    requestBody,
  }: {
    requestBody: MailForm,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/login/password/reset/send_mail',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
      },
    });
  }

  /**
   * ログアウト
   * @returns any OK
   * @throws ApiError
   */
  public static logout(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/logout',
    });
  }

}
